import React, { Component } from 'react'

import { DefaultStyles as theme } from './theme'
import { AuthorizedDisplay } from '@containers/common/auth'
import { Checkbox, Button, DateTextInput } from '@components/common/form'
import { YSpacing, FlexContainer } from '@components/common'
import { ValidationsModal } from '@components/groupOrders'
import { EditDateMenuCutoffModal } from '@components/groupOrders'
import TooltipModal from '@components/common/modal/TooltipModal'
import {
  MenuConcept,
  SearchGroupOrderConceptsProps,
} from '@components/common/modal/PickMenuModal/types'
import PickMenuModal from '@components/common/modal/PickMenuModal'
import moment from 'moment-timezone'
import { FaPlus, FaTrash, FaTrashAlt } from 'react-icons/fa'
import { BiPencil } from 'react-icons/bi'
import {
  AvailableMenuItemModGroup,
  DateMenus,
  DateMenusDraft,
  GroupOrderCustomServiceFee,
  GroupOrderMenuItemType,
  Menu,
  MenuItem,
  ServiceDay,
  OffDay,
} from '@types'

import {
  GROUP_ORDER_SUBSIDY_TYPE_FIXED,
  GROUP_ORDER_SUBSIDY_TYPE_PERCENT,
  GROUP_ORDER_SUBSIDY_TYPE_REVERSE,
  GROUP_ORDER_ITEM_TYPE_ENTREE,
  GROUP_ORDER_ITEM_TYPE_SIDE,
  GROUP_ORDER_ITEM_TYPE_ALL,
} from './constants'
import {
  GetMenuCutoffTime,
  GetMenuPickupTime,
  GetUpdatedDateMenusAfterCutoffChange,
  hasAnyMenuItemMods,
  moneyString,
} from '../../../utils'
import {
  ValidateDateMenus,
  GetUniqueMenuItemsCountForDateMenus,
  GetNextMenuItemsForMenuSync,
  getSortedModGroups,
  getSortedMods,
  getDefaultCutoffTime,
  getDefaultDropoffTime,
} from '../../../utils/groupOrderUtils'

type Props = {
  headquarter?: any
  locale?: any
  groupOrderMinimumItems?: any
  clientId?: any
  client?: any
  clientSettingsId?: any
  clientSettings?: any
  clientGlobalSettings?: any
  groupOrder?: any
  date?: any
  dateMenuId?: any
  dateMenus?: any
  changedDateMenuMap?: any
  hasActiveOrders?: any
  validateMenus?: any
  perOrderSubsidy?: any
  subsidyPercentLimitAmt?: any
  subsidyType?: any
  isSubsidyPercentLimit?: any
  countMap?: any
  forCalendarModal?: any
  itemPriceSettings?: any
  scheduleSettings?: any

  deleteDateMenus?: any
  getGroupOrderConcept?: any
  getGroupOrderUniversalConcept?: any
  getGroupOrderBySettingsDate?: any
  newDateMenu?: any
  saveDateMenu?: any
  searchGroupOrderConcepts?: any
  showCustomModal?: any
  showConfirmationModal: (obj: { text: string }) => Promise<boolean>
  displayFailureMessage?: any
  displayWarningMessage?: any
  displaySuccessMessage?: any
  fetchAndMergeMenuItemModifications?: any
  setChangedDateMenuMap?: any
  updateDateMenus?: any
  onReloadDates?: any
  loadMenuItemRatings?: any
  loadMenuItemSettings: any

  hideModal?: any

  validateChefPickupTimes: any
  getConceptEstPricePerPerson: any
  scheduledServiceDay?: ServiceDay | null
  scheduledOffDay?: OffDay | null
}

type State = {
  dateMenu?: Partial<DateMenusDraft> | DateMenus
  groupOrder?: any
  dates?: any
  editCutoffMenu: Menu | undefined
  editCutoffTimeModal: boolean
  showMenu?: any
  newMenuIds?: any
  menusToDelete?: any
  warningsModalOpen?: any
  updatedCutoffMap: Record<string, boolean>
  validationErrors?: any
  validationWarnings?: any
  pickupsConfirmed?: boolean
  expandedMenuItemModGroupsMap: Record<string, boolean>
}

class DateMenusComponent extends Component<Props, State> {
  state = {
    dateMenu: undefined,
    groupOrder: undefined,
    dates: [],
    editCutoffMenu: undefined,
    editCutoffTimeModal: false,
    showMenu: undefined,
    newMenuIds: [],
    menusToDelete: [],
    warningsModalOpen: false,
    updatedCutoffMap: {},
    validationErrors: [],
    validationWarnings: [],
    pickupsConfirmed: false,
    expandedMenuItemModGroupsMap: {} as Record<string, boolean>,
  }

  changed = false
  changedMenu = false

  componentWillMount() {
    const { date, dateMenus, dateMenuId, clientSettingsId } = this.props
    this.loadDateMenu(date, dateMenus, dateMenuId, clientSettingsId)
  }

  componentWillReceiveProps(nextProps: Props) {
    const { date, dateMenus, dateMenuId, clientSettingsId } = nextProps
    if (
      date !== this.props.date ||
      dateMenus !== this.props.dateMenus ||
      dateMenuId !== this.props.dateMenuId
    ) {
      this.loadDateMenu(date, dateMenus, dateMenuId, clientSettingsId)
    }
  }

  onToggleMenuItemModGroupsExpanded = (menuItemId: string) => {
    const { expandedMenuItemModGroupsMap } = this.state

    const nextValue = { ...expandedMenuItemModGroupsMap }

    if (expandedMenuItemModGroupsMap[menuItemId]) {
      nextValue[menuItemId] = false
    } else {
      nextValue[menuItemId] = true
    }

    this.setState({ expandedMenuItemModGroupsMap: nextValue })
  }

  onCloseWarningsModal = () => {
    this.setState({
      warningsModalOpen: false,
      validationErrors: [],
      validationWarnings: [],
    })
  }

  loadDateMenu = (
    date: any,
    dateMenus: any,
    dateMenuId: any,
    clientSettingsId: any,
  ) => {
    let newDateMenu = dateMenus.find((dm: any) => dm.id === dateMenuId)
    if (!newDateMenu) {
      //try and get it by the dateStr
      newDateMenu = dateMenus.find((dm: any) => dm.dateStr === dateMenuId)
    }
    if (!dateMenuId) {
      //dateMenu is from groupOrdersPage, use date to find it instead
      newDateMenu = dateMenus.find((dm: any) => {
        return (
          date.isSame(dm.date, 'day') &&
          dm.clientSettingsId === clientSettingsId
        )
      })
    }
    this.setDateMenu(date, newDateMenu)
  }

  setDateMenu = (nDate: any, dateMenu: any) => {
    const {
      newDateMenu,
      clientId,
      clientSettingsId,
      locale,
      scheduleSettings,
    } = this.props
    const cutoffTime = getDefaultCutoffTime(
      moment(nDate),
      locale,
      scheduleSettings,
    )
    const date = getDefaultDropoffTime(moment(nDate), locale, scheduleSettings)

    if (dateMenu) {
      this.setState({
        dateMenu,
        updatedCutoffMap: {},
      })
    } else {
      const newDate = newDateMenu()
      this.setState(
        {
          dateMenu: {
            ...newDate,
            clientId,
            clientSettingsId,
            date,
            cutoffTime,
            dateStr: date.format('YYYY-MM-DD'),
          },
          updatedCutoffMap: {},
        },
        () => this.applyCustomServiceFees(),
      )
    }
  }

  getCustomServiceFees = (): GroupOrderCustomServiceFee[] | null => {
    const {
      client,
      clientGlobalSettings: { customServiceFeeSettings: globalFeeSettings },
      clientSettings: { customServiceFeeSettings: locationFeeSettings },
    } = this.props

    let feeSettings = null
    if (globalFeeSettings) {
      feeSettings = globalFeeSettings.serviceFees
    } else if (locationFeeSettings) {
      feeSettings = locationFeeSettings.serviceFees
    } else if ((client.accountCustomServiceFees || []).length > 0) {
      feeSettings = client.accountCustomServiceFees
    }

    return feeSettings
  }

  applyCustomServiceFees = () => {
    const { dateMenu } = this.state
    if (!dateMenu) {
      return
    }

    const feeSettings = this.getCustomServiceFees()
    if (!feeSettings) {
      return
    }

    this.setState({
      dateMenu: {
        ...(dateMenu as any),
        customServiceFees: {
          serviceFees: feeSettings,
        },
      },
    })
  }

  validateMenuToDateMenu = (dateMenu: any, menu: any) => {
    const { date } = dateMenu
    const { availableDays } = menu

    if (!availableDays.includes(moment(date).day())) {
      return 'Unable to select menu as it is not available for the selected day of the week.'
    }

    // Do not allow adding menus with a cutoff time that has already passed
    if (moment().isSameOrAfter(menu.cutoffTime)) {
      return `Unable to select menu because its cutoff time has already passed: ${moment(
        menu.cutoffTime,
      ).format('lll z')}`
    }

    // Do not allow adding menus with a pickup time before date menus dropoff time
    if (menu.pickupTime && moment(menu.pickupTime).isSameOrAfter(date)) {
      return `Unable to select menu because its earliest pickup time is set to ${moment(
        menu.pickupTime,
      ).format('lll z')} which is after the event's dropoff time.`
    }

    const itemsWithMutipleMealTypes = menu.menuItems.filter((item: any) => {
      return item.mealTypes.length > 1
    })

    if (itemsWithMutipleMealTypes.length) {
      let msg = `Menu "${menu.name}" for Chef ${menu.chef.name} has items with multiple GO meal type tags. Please update the following menu items to have only 1 GO meal type tag:\n`
      itemsWithMutipleMealTypes.forEach((item: any) => {
        msg += `${item.name}\n`
      })

      return msg
    }

    return null
  }

  onShowPickMenuModal = async () => {
    const {
      locale,
      showCustomModal,
      showConfirmationModal,
      loadMenuItemSettings,
      clientSettings,
      scheduledOffDay,
      scheduledServiceDay,
    } = this.props
    const { dateMenu }: { dateMenu: any } = this.state

    // Gate: warn before adding a menu to an off day or unscheduled day
    if (scheduledOffDay) {
      const parts = [
        `This date is scheduled as a day off (${scheduledOffDay.scheduleName}).`,
        scheduledOffDay.reason ? `Reason: ${scheduledOffDay.reason}` : '',
        scheduledOffDay.notes ? `Notes: ${scheduledOffDay.notes}` : '',
        '\nAre you sure you want to add a menu anyway?',
      ]
        .filter(Boolean)
        .join('\n')
      const confirmed = await showConfirmationModal({ text: parts })
      if (!confirmed) {
        return
      }
    } else if (!scheduledServiceDay) {
      const confirmed = await showConfirmationModal({
        text: 'This date does not have a designated delivery schedule.\n\nAre you sure you want to add a menu anyway?',
      })
      if (!confirmed) {
        return
      }
    }
    let currDate: moment.Moment = moment()
    const date = dateMenu?.date
    if (date) {
      currDate =
        typeof date === 'string' ? moment.tz(date, locale) : date.tz(locale)
    }
    showCustomModal({
      width: '1800px',
      title: 'Pick Menu',
      content: (
        <PickMenuModal
          clientSettings={clientSettings}
          loadMenuItemSettings={loadMenuItemSettings}
          date={currDate}
          searchMenuConcepts={async (req: SearchGroupOrderConceptsProps) => {
            const { searchGroupOrderConcepts } = this.props
            const menus = await searchGroupOrderConcepts(req)

            return menus
          }}
          onPickMenu={this.onSelectMenu}
        />
      ),
    })
  }

  onSelectMenu = async (menu: MenuConcept) => {
    const {
      validateMenus,
      perOrderSubsidy,
      displaySuccessMessage,
      displayFailureMessage,
      subsidyType,
      subsidyPercentLimitAmt,
      isSubsidyPercentLimit,
      itemPriceSettings,
      locale,
      fetchAndMergeMenuItemModifications,
    } = this.props
    const { newMenuIds } = this.state
    const { dateMenu }: { dateMenu: any } = this.state
    if (dateMenu.menus.find((m: any) => m.id === menu.id)) {
      return
    }
    const menuName = `${menu.name} (${menu.chef.name})`
    const { menuWithMods, modErrorMssg } =
      await fetchAndMergeMenuItemModifications(menu)
    if (modErrorMssg) {
      return displayFailureMessage(`${menuName}: ${modErrorMssg}`)
    }

    // Calculate menu-level times
    menu = {
      ...menuWithMods,
      cutoffTime: GetMenuCutoffTime(menu, dateMenu, locale),
      pickupTime: GetMenuPickupTime(menu, dateMenu, locale),
    }

    const menuMessage = this.validateMenuToDateMenu(dateMenu, menu)
    if (menuMessage) {
      return displayFailureMessage(`${menuName}: ${menuMessage}`)
    }

    if (validateMenus) {
      if (subsidyType === GROUP_ORDER_SUBSIDY_TYPE_FIXED) {
        const aboveSubsidy = menu.menuItems.some(
          (item: any) => item.price > perOrderSubsidy,
        )
        if (aboveSubsidy) {
          const message =
            'Unable to select menu as some items are above the subsidy per order amount.'

          return displayFailureMessage(`${menuName}: ${message}`)
        }
      } else if (
        subsidyType === GROUP_ORDER_SUBSIDY_TYPE_PERCENT &&
        isSubsidyPercentLimit &&
        typeof subsidyPercentLimitAmt === 'number'
      ) {
        const aboveSubsidy = menu.menuItems.some(
          (item: any) => item.price > subsidyPercentLimitAmt,
        )
        if (aboveSubsidy) {
          const message =
            'Unable to select menu as some items are above the subsidy per order amount.'

          return displayFailureMessage(`${menuName}: ${message}`)
        }
      } else if (
        subsidyType === GROUP_ORDER_SUBSIDY_TYPE_REVERSE &&
        !!itemPriceSettings &&
        !!itemPriceSettings.budgets
      ) {
        if (
          Object.keys(itemPriceSettings.budgets).includes(
            GROUP_ORDER_ITEM_TYPE_ALL,
          )
        ) {
          const aboveSubsidy = menu.menuItems.some(
            (item: any) =>
              item.price >
              parseFloat(
                itemPriceSettings.budgets[GROUP_ORDER_ITEM_TYPE_ALL].budget,
              ),
          )
          if (aboveSubsidy) {
            const message =
              'Unable to select menu as some items are above the subsidy per order amount.'

            return displayFailureMessage(`${menuName}: ${message}`)
          }
        } else {
          if (
            Object.keys(itemPriceSettings.budgets).includes(
              GROUP_ORDER_ITEM_TYPE_ENTREE,
            )
          ) {
            const aboveSubsidy = menu.menuItems
              .filter((m: any) => m.itemType === GROUP_ORDER_ITEM_TYPE_ENTREE)
              .some(
                (item: any) =>
                  item.price >
                  parseFloat(
                    itemPriceSettings.budgets[GROUP_ORDER_ITEM_TYPE_ENTREE]
                      .budget,
                  ),
              )
            if (aboveSubsidy) {
              const message =
                'Unable to select menu as entree items are above the client budget per order amount.'

              return displayFailureMessage(`${menuName}: ${message}`)
            }
          }
          if (
            Object.keys(itemPriceSettings.budgets).includes(
              GROUP_ORDER_ITEM_TYPE_SIDE,
            )
          ) {
            const aboveSubsidy = menu.menuItems
              .filter((m: any) => m.itemType === GROUP_ORDER_ITEM_TYPE_SIDE)
              .some(
                (item: any) =>
                  item.price >
                  parseFloat(
                    itemPriceSettings.budgets[GROUP_ORDER_ITEM_TYPE_SIDE]
                      .budget,
                  ),
              )
            if (aboveSubsidy) {
              const message =
                'Unable to select menu as side items are above the client budget per order amount.'

              return displayFailureMessage(`${menuName}: ${message}`)
            }
          }
        }
      }
    }
    const zeroChefPrice = menu.menuItems.some(
      (item: any) => item.chefPrice === 0,
    )
    if (zeroChefPrice) {
      const message =
        'Unable to select menu as some items do not contain accurate price for chef.'

      return displayFailureMessage(`${menuName}: ${message}`)
    }
    const zeroMarketPrice = menu.menuItems.some((item: any) => item.price === 0)
    if (zeroMarketPrice) {
      const message =
        'Unable to select menu as some items do not contain accurate market price.'

      return displayFailureMessage(`${menuName}: ${message}`)
    }

    const { entreesTotal, sidesTotal, pricePerPerson } =
      await this.props.getConceptEstPricePerPerson(
        menu.menuItems
          .filter((item: any) => item.itemType === GROUP_ORDER_ITEM_TYPE_ENTREE)
          .map((item: any) => item.id),
        menu.menuItems
          .filter((item: any) => item.itemType === GROUP_ORDER_ITEM_TYPE_SIDE)
          .map((item: any) => item.id),
      )
    const conceptEstPPP = {
      all: pricePerPerson,
      entrees: entreesTotal,
      sides: sidesTotal,
    }

    this.setState(
      {
        dateMenu: {
          ...dateMenu,
          menus: [
            ...dateMenu.menus,
            { ...menu, active: false, pricingInfo: conceptEstPPP },
          ],
        },
        newMenuIds: [...newMenuIds, menu.id],
        pickupsConfirmed: false,
      },
      () => this.loadMenuItemRatings(menu.id, menu.menuItems),
    )

    return displaySuccessMessage(`Added menu "${menuName}"`)
  }

  loadMenuItemRatings = async (menuId: any, items: any) => {
    const { dateMenu }: { dateMenu: any } = this.state
    const { loadMenuItemRatings } = this.props
    const ratings = await loadMenuItemRatings(items.map((item: any) => item.id))

    this.setState({
      dateMenu: {
        ...dateMenu,
        menus: dateMenu.menus.map((menu: any) => {
          if (menu.id === menuId) {
            return {
              ...menu,
              menuItems: items.map((item: any) => {
                return {
                  ...item,
                  ratingInfo: {
                    averageRating: ratings[item.id].rating,
                    numRatings: ratings[item.id].count,
                  },
                }
              }),
            }
          }

          return menu
        }),
      },
    })
  }

  onRemoveMenu = (idx: any, menuId: any) => {
    const { newMenuIds, menusToDelete } = this.state
    const { dateMenu }: { dateMenu: any } = this.state
    const menu = dateMenu.menus[idx]
    const menus = [
      ...dateMenu.menus.slice(0, idx),
      ...dateMenu.menus.slice(idx + 1),
    ]
    const newIndex = newMenuIds.find((id) => id === menuId)
    // TODO: this check is incorrect; newIndex will either be undefined or the found item id (NOT an index)
    if ((newIndex as unknown as number) > -1) {
      this.setState({ dateMenu: { ...dateMenu, menus }, newMenuIds })
    } else {
      this.setState({
        dateMenu: { ...dateMenu, menus },
        menusToDelete: [...menusToDelete, menu.id],
      })
    }
    this.changedMenu = true
  }

  onChangeMenuActive = (idx: any) => (e: any) => {
    const { dateMenu }: { dateMenu: any } = this.state
    const { changedDateMenuMap, setChangedDateMenuMap } = this.props
    const { menus } = dateMenu
    const menu = menus[idx]
    const newState: any = {
      dateMenu: {
        ...dateMenu,
        menus: [
          ...menus.slice(0, idx),
          { ...menu, active: e.target.checked },
          ...menus.slice(idx + 1, menus.length),
        ],
      },
    }
    newState.changedActive = true
    this.changedMenu = true

    this.setState(newState, () => {
      const mapKey = dateMenu.id || dateMenu.dateStr
      const mapEntry =
        changedDateMenuMap &&
        changedDateMenuMap[mapKey] &&
        changedDateMenuMap[mapKey][menu.id]
      if (!mapEntry) {
        changedDateMenuMap[mapKey] = { ...changedDateMenuMap[mapKey] }
        changedDateMenuMap[mapKey][menu.id] = {}
        setChangedDateMenuMap({ ...changedDateMenuMap })
      } else if (mapEntry && !mapEntry['_new']) {
        const newMap = { ...changedDateMenuMap }
        delete newMap[mapKey][menu.id]
        setChangedDateMenuMap(newMap)
      }
    })
  }

  onSyncMenu = async (menu: Menu) => {
    const {
      getGroupOrderConcept,
      getGroupOrderUniversalConcept,
      clientSettingsId,
      date,
      locale,
      clientSettings,
      displayWarningMessage,
      getConceptEstPricePerPerson,
      getGroupOrderBySettingsDate,
    } = this.props
    const { dateMenu = {}, updatedCutoffMap }: State = this.state
    const { id: menuId, isUniversal, excludedItemIds } = menu
    let latestMenu: Menu
    if (isUniversal) {
      latestMenu = await getGroupOrderUniversalConcept(
        menuId,
        clientSettings.universalMenuConfig,
        excludedItemIds,
      )
    } else {
      latestMenu = await getGroupOrderConcept(menuId)
    }
    if (!latestMenu) {
      return
    }

    if (dateMenu?.menus) {
      const groupOrder = await getGroupOrderBySettingsDate({
        settingsId: clientSettingsId,
        date: date.format('YYYY-MM-DD'),
      })
      const { entreesTotal, sidesTotal, pricePerPerson } =
        await getConceptEstPricePerPerson(
          latestMenu.menuItems
            .filter(
              (item: any) => item.itemType === GROUP_ORDER_ITEM_TYPE_ENTREE,
            )
            .map((item: any) => item.id),
          latestMenu.menuItems
            .filter((item: any) => item.itemType === GROUP_ORDER_ITEM_TYPE_SIDE)
            .map((item: any) => item.id),
        )
      const conceptEstPPP = {
        all: pricePerPerson,
        entrees: entreesTotal,
        sides: sidesTotal,
      }

      // update menu without removing items that already have orders placed
      const menus = dateMenu.menus.map((menu: Menu) => {
        const isMenuToSync = menu.id === menuId
        if (!isMenuToSync) {
          return menu
        }

        const { menuItems, warnings } = GetNextMenuItemsForMenuSync(
          menu,
          latestMenu,
          groupOrder?.orders || [],
        )

        if (warnings.length) {
          const msg = warnings.map((warning) => warning.msg).join('\n\n')
          displayWarningMessage(msg)
        }

        return {
          ...menu,
          ...latestMenu,
          cutoffTime: updatedCutoffMap[menu.id]
            ? menu.cutoffTime
            : GetMenuCutoffTime(latestMenu, dateMenu, locale),
          pickupTime: GetMenuPickupTime(latestMenu, dateMenu, locale),
          menuItems,
          pricingInfo: conceptEstPPP,
        }
      })

      this.changed = true
      this.setState({
        dateMenu: { ...dateMenu, menus },
      })
    }
  }

  onStageMenus = async (skipWarnings = false) => {
    const { newMenuIds, menusToDelete, pickupsConfirmed } = this.state
    const { dateMenu }: { dateMenu: any } = this.state
    const {
      hasActiveOrders,
      hideModal,
      saveDateMenu,
      forCalendarModal,
      updateDateMenus,
      changedDateMenuMap,
      dateMenus,
      clientSettings,
      groupOrder,
      displayFailureMessage,
      locale,
      groupOrderMinimumItems,
      validateChefPickupTimes,
    } = this.props
    const { doNotArriveBeforeTime } = clientSettings

    const { cutoffTime, date } = dateMenu
    if (
      (!newMenuIds || newMenuIds.length <= 0) &&
      menusToDelete.length === 0 &&
      !this.changed &&
      !this.changedMenu
    ) {
      const message = 'No changes to stage.'

      return displayFailureMessage(message)
    }
    const errorList = []
    // Validate order date/time against client "Do Not Arrive Before" setting
    // Date/time can be updated after creation, but not once the order has active orders
    // Validation is only enforced if there are no active orders
    if (doNotArriveBeforeTime && !hasActiveOrders) {
      const hour = Math.floor(doNotArriveBeforeTime / 100)
      const minute = doNotArriveBeforeTime % 100
      const doNotArriveBeforeMoment = moment(date)
        .clone()
        .hour(hour)
        .minute(minute)
        .second(0)
      if (moment(date).isBefore(doNotArriveBeforeMoment)) {
        errorList.push(
          "Dropoff time cannot be earlier than the client's 'Do Not Arrive Before'",
        )
      }
    }
    if (moment(cutoffTime).isSameOrAfter(date)) {
      errorList.push('Dropoff time must be after cutoff time')
    }

    if (errorList.length > 0) {
      const errorString =
        'Please check the following errors:\n' +
        '• ' +
        errorList.join('.\n• ') +
        '.'
      displayFailureMessage(errorString)

      return
    }
    //only for saving directly from the component on the client tab
    const mapKey = dateMenu.id || dateMenu.dateStr
    let changedMap = { ...changedDateMenuMap[mapKey] }
    if (!changedMap) {
      changedMap = {}
    }
    dateMenu.menus.forEach((menu: any) => {
      if (this.changed) {
        changedMap[menu.id] = {}
      }
      if (menusToDelete.find((id) => id === menu.id)) {
        changedMap[menu.id] = { _destroy: true }
      }
      if (newMenuIds.find((id) => id === menu.id)) {
        changedMap[menu.id] = { _new: true }
      }
    })

    const { warnings } = ValidateDateMenus(
      dateMenu,
      clientSettings,
      groupOrder,
      locale,
      groupOrderMinimumItems,
    )

    // Prepend schedule warnings so they appear first in the modal
    const { scheduledOffDay, scheduledServiceDay } = this.props
    if (scheduledOffDay) {
      const parts = [
        `This date is scheduled as a day off (${scheduledOffDay.scheduleName}).`,
        scheduledOffDay.reason ? `Reason: ${scheduledOffDay.reason}` : '',
        scheduledOffDay.notes ? `Notes: ${scheduledOffDay.notes}` : '',
      ]
        .filter(Boolean)
        .join(' ')
      warnings.unshift(parts)
    } else if (!scheduledServiceDay) {
      warnings.unshift(
        'This date does not have a designated delivery schedule.',
      )
    }

    if (!pickupsConfirmed) {
      const pickupTimesConfirmed = await validateChefPickupTimes({
        orderType: 'Group Order',
        orderSetupTime: moment(dateMenu.date).tz(locale).format(),
        chefIds: dateMenu.menus.map((menu: Menu) => menu.chef.id),
        headquarterId: this.props.headquarter,
      })
      if (!pickupTimesConfirmed) {
        return
      } else {
        this.setState({ pickupsConfirmed: true })
      }
    }

    if (warnings.length && !skipWarnings) {
      this.setState({
        warningsModalOpen: true,
        validationWarnings: warnings,
      })

      return
    }

    // Close and reset warnings modal if open
    this.setState({
      warningsModalOpen: false,
      validationErrors: [],
      validationWarnings: [],
    })

    if (forCalendarModal) {
      const newMap = { ...changedDateMenuMap }
      newMap[mapKey] = changedMap
      const dateMenuIndex = dateMenus.findIndex((dm: any) => dm.id === mapKey)

      if (dateMenuIndex <= -1) {
        // remove duplicate menus
        const duplicateDateIndex = dateMenus.findIndex(
          (date: any) => date.dateStr === dateMenu.dateStr,
        )
        if (duplicateDateIndex >= 0) {
          const newDateMenus = [...dateMenus]
          newDateMenus[duplicateDateIndex] = dateMenu
          await updateDateMenus({
            dateMenus: newDateMenus,
            changedDateMenuMap: newMap,
          })
        } else {
          await updateDateMenus({
            dateMenus: [...dateMenus, { ...dateMenu }],
            changedDateMenuMap: newMap,
          })
        }
      } else {
        dateMenus.splice(dateMenuIndex, 1, dateMenu)
        const newDateMenus = [...dateMenus]
        await updateDateMenus({
          dateMenus: newDateMenus,
          changedDateMenuMap: newMap,
        })
      }
    } else {
      // When saving date menus, ensure that all event menus cutoff times are set correctly,
      // which is always in relation to date menus cutoff time
      const nextDateMenu = GetUpdatedDateMenusAfterCutoffChange(
        dateMenu,
        locale,
      )

      const saveSuccess = await saveDateMenu({
        dateMenu: nextDateMenu,
        changedDateMenuMap: changedDateMenuMap[mapKey],
        dateStr: dateMenu.dateStr,
      })
      if (saveSuccess) {
        this.setState({ dateMenu: nextDateMenu })
        this.props.onReloadDates()
      }
    }
    // TODO: verify this is correct; I believe tihs was a typo
    this.setState({ newMenuIds: [], menusToDelete: [], updatedCutoffMap: {} })
    hideModal && hideModal()
  }

  onChangeTime = async (key: any, value: any) => {
    const { locale } = this.props
    const { dateMenu }: { dateMenu: any } = this.state
    //DateTextInput does not update when date attribute is changed; reverts to today's date
    if (['date', 'cutoffTime'].includes(key)) {
      const mVal = moment(value)
      const locDate = moment.tz(this.props.date, locale)
      value = locDate.set({ h: mVal.hour(), m: mVal.minutes(), s: 0 })
    }
    this.changed = true
    this.setState({
      dateMenu: {
        ...dateMenu,
        [key]: value,
      },
    })
  }

  onChangeDateTime = async (key: any, value: any) => {
    this.changed = true
    const { dateMenu }: { dateMenu: any } = this.state

    this.setState({
      dateMenu: {
        ...dateMenu,
        [key]: value,
      },
    })
  }

  handleSaveCutoffTime = (menu: Menu) => {
    const { dateMenu = {}, updatedCutoffMap }: State = this.state
    if (dateMenu?.menus) {
      const menuIdx: number = dateMenu.menus.findIndex(
        (m: Menu) => m.id === menu.id,
      )
      if (menuIdx < 0) {
        return
      }
      dateMenu.menus[menuIdx] = menu
      this.changed = true
      updatedCutoffMap[menu.id] = true
      this.setState({
        dateMenu,
        editCutoffMenu: undefined,
        editCutoffTimeModal: false,
        updatedCutoffMap,
      })
    }
  }

  getUniqueMenuItemsCount = () => {
    const {
      dateMenu,
      groupOrder,
    }: {
      dateMenu: any
      groupOrder: any
    } = this.state

    return GetUniqueMenuItemsCountForDateMenus(dateMenu, groupOrder)
  }

  renderMenuItems = (items: MenuItem[], label: string) => {
    return (
      <div className="group-menu-items">
        <FlexContainer
          flexDirection="row"
          alignItems="center"
          justifyContent="space-apart"
        >
          <p className="group-menu-items-title">{label}</p>
          {hasAnyMenuItemMods(items) && (
            <TooltipModal
              unicode="&#9888;"
              width="400px"
              information='*Totals shown below are for base menu items only. To see user modifications, view individual orders in the "Orders" tab.'
              marginTop="20px"
              color="red"
            />
          )}
        </FlexContainer>
        {items.map(this.renderMenuItem)}
      </div>
    )
  }

  renderMenuItem = (item: MenuItem) => {
    const { countMap } = this.props
    const { expandedMenuItemModGroupsMap } = this.state
    const { averageRating, numRatings } = item.ratingInfo || {}
    const price = moneyString(item.price)

    const modsButtonLabel = expandedMenuItemModGroupsMap[item.id]
      ? 'Hide Mods'
      : 'Show Mods'

    return (
      <div className="group-menu-item-container" key={item.id}>
        <div className="group-menu-item-info">
          {item.name} | ${price} | Rating:{' '}
          {numRatings && numRatings !== 0 && typeof averageRating === 'number'
            ? `${averageRating.toFixed(2)} ⭐ (${numRatings})`
            : 'N/A'}{' '}
          | Orders: {countMap[item.id] || 0}
        </div>
        {item.availableModGroups.length > 0 && (
          <div className="item-mod-groups-section">
            <button
              className="toggle-mod-groups-button"
              onClick={() => this.onToggleMenuItemModGroupsExpanded(item.id)}
            >
              {modsButtonLabel}
            </button>
            {expandedMenuItemModGroupsMap[item.id] && (
              <div className="mod-groups-container">
                {getSortedModGroups(item.availableModGroups).map(
                  this.renderModGroup,
                )}
              </div>
            )}
          </div>
        )}
      </div>
    )
  }

  renderModGroup = (modGroup: AvailableMenuItemModGroup) => {
    return (
      <div className="mod-group-container" key={modGroup.id}>
        <div className="mod-group-info">
          <div className="mod-group-verb">{modGroup.verb}</div>
          <div className="mod-group-name">{modGroup.name}</div>
        </div>
        <div className="mods-container">
          {getSortedMods(modGroup.availableMods).map((mod) => (
            <div className="mod" key={mod.id}>
              <div className="mod-name">{mod.name}</div>
              <div className="mod-price">${moneyString(mod.clientPrice)}</div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  getBudgetPerPersonValue = () => {
    const { clientGlobalSettings, clientSettingsId } = this.props
    if (!clientGlobalSettings) {
      return null
    }

    const { budgetPerPersonSettings, isCustomBudgetPerPerson } =
      clientGlobalSettings

    if (isCustomBudgetPerPerson) {
      return (budgetPerPersonSettings || {})[clientSettingsId]?.value || null
    }

    return budgetPerPersonSettings?.all?.value || null
  }

  renderBudgetPerPerson = () => {
    const { clientGlobalSettings, clientSettingsId, clientSettings } =
      this.props
    if (!clientGlobalSettings) {
      return null
    }

    const { budgetPerPersonSettings, isCustomBudgetPerPerson } =
      clientGlobalSettings

    let label = 'Client Budget for Location all Locations'
    let budgetSettings
    if (isCustomBudgetPerPerson) {
      label = `Client Budget for Location: ${
        clientSettings?.name === ''
          ? 'Unnamed Default Location'
          : clientSettings?.name
      }`
      budgetSettings = (budgetPerPersonSettings || {})[clientSettingsId]
    } else {
      label = 'Client Budget for Location all Locations'
      budgetSettings = budgetPerPersonSettings?.all
    }

    if (!budgetSettings) {
      return null
    }

    const budgetType =
      budgetSettings.type === 'allIn'
        ? 'All-In (Includes Fees)'
        : 'Food Only (Excludes Fees)'

    return (
      <div className="budget-per-person-container">
        <p className="font-semibold uppercase">{label}</p>
        <p>
          ${budgetSettings.value.toFixed(2)} per person, {budgetType}
        </p>
      </div>
    )
  }

  onRemoveCustomServiceFee = (idx: number) => {
    const { dateMenu } = this.state
    if (!dateMenu) {
      return
    }

    const { customServiceFees } = dateMenu as DateMenus
    if (!customServiceFees) {
      return
    }

    const newCustomServiceFees = [...customServiceFees.serviceFees]
    newCustomServiceFees.splice(idx, 1)

    this.setState({
      dateMenu: {
        ...(dateMenu as any),
        customServiceFees: {
          serviceFees: newCustomServiceFees,
        },
      },
    })
  }

  onAddCustomServiceFee = (fee: GroupOrderCustomServiceFee) => {
    const { dateMenu } = this.state
    if (!dateMenu) {
      return
    }

    const { customServiceFees } = dateMenu as DateMenus
    const newFees = [...(customServiceFees?.serviceFees || []), fee]

    this.setState({
      dateMenu: {
        ...(dateMenu as any),
        customServiceFees: {
          serviceFees: newFees,
        },
      },
    })
  }

  renderCustomServiceFees = () => {
    const { dateMenu } = this.state
    if (!dateMenu) {
      return null
    }

    const { customServiceFees } = dateMenu as DateMenus
    if (!customServiceFees) {
      return null
    }

    const availableFees = this.getCustomServiceFees()
    const unappliedFees = (availableFees || []).filter(
      (fee) =>
        !customServiceFees.serviceFees.some(
          (f) => f.feeDescription === fee.feeDescription,
        ),
    )

    return (
      <div className="w-full">
        <label className="sidebar-body-label">Custom Service Fees</label>
        <YSpacing height="10px" />
        <FlexContainer flexDirection="column" width="100%">
          {customServiceFees.serviceFees.map((fee, idx) => (
            <div
              key={`custom-service-fee-${idx}`}
              className="flex flex-row items-center mb-2 w-full"
            >
              <AuthorizedDisplay
                roles={['master admin', 'sales lead', 'finance']}
                width="10%"
              >
                <button
                  className="mr-1"
                  onClick={() => this.onRemoveCustomServiceFee(idx)}
                >
                  <FaTrashAlt size={16} />
                </button>
              </AuthorizedDisplay>
              <p
                className="py-1 px-2 bg-gray-300 rounded-lg text-xs mr-2 font-semibold text-center"
                style={{ width: 'min-content' }}
              >
                {fee.serviceFeeType}
              </p>
              <p>{fee.feeDescription}</p>
              {fee.valueCalculationType === 'Flat Price' ? (
                <p>{`, $${fee.value}`}</p>
              ) : (
                <p>{`, ${fee.percentValue}% of subtotal`}</p>
              )}
              {!fee.isTaxExempt && <p>{`, Taxable: ${fee.itemTaxCode}`}</p>}
            </div>
          ))}
        </FlexContainer>
        {unappliedFees.length > 0 && (
          <AuthorizedDisplay roles={['master admin', 'sales lead', 'finance']}>
            <YSpacing height="10px" />
            <label className="sidebar-body-label">Unapplied Fees</label>
            <YSpacing height="10px" />
            <FlexContainer flexDirection="column">
              {unappliedFees.map((fee) => (
                <div
                  key={`unapplied-fee-${fee.feeDescription}`}
                  className="flex flex-row items-center mb-2"
                >
                  <p>{fee.feeDescription}</p>
                  <button
                    className="ml-2"
                    onClick={() => this.onAddCustomServiceFee(fee)}
                  >
                    <FaPlus size={16} />
                  </button>
                </div>
              ))}
            </FlexContainer>
          </AuthorizedDisplay>
        )}
      </div>
    )
  }

  render() {
    const {
      dateMenu = {},
      editCutoffTimeModal,
      editCutoffMenu,
      showMenu,
      updatedCutoffMap,
    }: State = this.state
    const { groupOrderMinimumItems } = this.props
    let date, cutoffTime, menus
    let currDate: moment.Moment = moment()
    let formattedCutoff = ''
    if (dateMenu) {
      ;({ menus, date, cutoffTime } = dateMenu)
    }
    const { locale, countMap, hasActiveOrders, forCalendarModal } = this.props
    if (date) {
      currDate =
        typeof date === 'string' ? moment.tz(date, locale) : date.tz(locale)
    }
    if (cutoffTime) {
      formattedCutoff =
        typeof cutoffTime === 'string' ? cutoffTime : cutoffTime.toJSON()
    }

    const { scheduledServiceDay, scheduledOffDay } = this.props

    return (
      <div>
        <YSpacing height="20px" />
        {scheduledOffDay && (
          <ScheduleBanner type="off">
            <ScheduleBannerTitle>⚠️ Day Off</ScheduleBannerTitle>
            <span>
              This date is scheduled as a day off
              {scheduledOffDay.scheduleName
                ? ` (${scheduledOffDay.scheduleName})`
                : ''}
              .
            </span>
            {scheduledOffDay.reason && (
              <ScheduleBannerRow>
                <strong>Reason:</strong> {scheduledOffDay.reason}
              </ScheduleBannerRow>
            )}
            {scheduledOffDay.notes && (
              <ScheduleBannerRow>
                <strong>Notes:</strong> {scheduledOffDay.notes}
              </ScheduleBannerRow>
            )}
          </ScheduleBanner>
        )}
        {!scheduledOffDay && !scheduledServiceDay && (
          <ScheduleBanner type="unscheduled">
            <ScheduleBannerTitle>⚠️ Not Scheduled</ScheduleBannerTitle>
            <span>This date does not have a designated delivery schedule.</span>
          </ScheduleBanner>
        )}
        {hasActiveOrders ? (
          <FlexContainer flexDirection="column">
            <div>
              <label className="sidebar-body-label">Cutoff Time</label>
              <p>{moment(cutoffTime).format('lll z')}</p>
            </div>
            <YSpacing height="10px" />
            <div>
              <label className="sidebar-body-label">
                Dropoff Time ({moment(date).format('M/DD')})
              </label>
              <p>{moment(date).format('h:mm a')}</p>
            </div>
          </FlexContainer>
        ) : (
          <FlexContainer flexDirection="column" justifyContent="space-between">
            <DateTextInput
              date={formattedCutoff}
              dateFormat="lll"
              label={`Cutoff Time (${currDate && currDate.format('z')})`}
              onChange={(e: any) => this.onChangeDateTime('cutoffTime', e)}
              timeZone={locale}
              width="75%"
            />
            <YSpacing height="10px" />
            <DateTextInput
              date={date}
              dateFormat="h:mm a"
              label={`Dropoff Time (${currDate && currDate.format('M/DD')})`}
              onChange={(e: any) => this.onChangeTime('date', e)}
              timeZone={locale}
              width="75%"
            />
          </FlexContainer>
        )}
        <YSpacing height="20px" />
        <DateTextInput
          className="input-background"
          label="Set Live Date"
          date={dateMenu.liveDate}
          onChange={(e: any) => this.onChangeTime('liveDate', e)}
          dateFormat="MM/DD/YYYY"
          timeZone={locale}
          placeholder="MM/DD/YYYY"
          width="100%"
        />
        <YSpacing height="20px" />
        {this.renderCustomServiceFees()}
        <YSpacing height="20px" />
        <FlexContainer flexDirection="column" justifyContent="space-between">
          <Button label="Search Menus" onClick={this.onShowPickMenuModal} />
          <YSpacing height="10px" />
          <Checkbox
            label="Active Delivery Date?"
            testId="activate-delivery-date"
            value={dateMenu.active}
            checked={dateMenu.active}
            onChange={(e: any) =>
              this.setState(
                { dateMenu: { ...dateMenu, active: e.target.checked } },
                () => (this.changed = true),
              )
            }
          />
        </FlexContainer>
        <YSpacing height="20px" />
        <label className="sidebar-body-label">Menus (Click to see items)</label>
        <YSpacing height="10px" />
        <div className="panel-legend">
          <span style={{ background: '#f89eac' }} />
          <p style={{ marginRight: '10px' }}>Non-active menus</p>
          <span style={{ background: '#facc15' }} />
          <p style={{ marginRight: '10px' }}>Over Client Budget</p>
        </div>
        <YSpacing height="10px" />
        <div className="go-items-counter-container">
          <div className="items-counter-group">
            <div className="items-counter-label">Unique items scheduled:</div>
            <div
              className={`items-counter-value ${
                this.getUniqueMenuItemsCount() >= groupOrderMinimumItems
                  ? 'min-reached'
                  : 'min-not-reached'
              }`}
            >
              {this.getUniqueMenuItemsCount()}
            </div>
          </div>
          <div className="items-counter-group">
            <div className="items-counter-label">
              Required min unique items:
            </div>
            <div className="items-counter-value">{groupOrderMinimumItems}</div>
          </div>
        </div>
        <YSpacing height="10px" />
        {this.renderBudgetPerPerson()}
        <YSpacing height="10px" />
        {(menus || []).length === 0 && (
          <div>
            <p>No menus selected for this day</p>
            <YSpacing height="10px" />
          </div>
        )}
        {(menus || []).map((menu, idx) => {
          const entrees = menu.menuItems.filter(
            (it) => it.itemType === GroupOrderMenuItemType.ENTREE,
          )
          const sides = menu.menuItems.filter(
            (it) =>
              it.itemType === GroupOrderMenuItemType.SIDE ||
              it.itemType === GroupOrderMenuItemType.STARCH_SIDE ||
              it.itemType === GroupOrderMenuItemType.VEGETABLE_SIDE,
          )
          const drinks = menu.menuItems.filter(
            (it) => it.itemType === GroupOrderMenuItemType.DRINK,
          )
          const desserts = menu.menuItems.filter(
            (it) => it.itemType === GroupOrderMenuItemType.DESSERT,
          )

          const menuPricePerPerson = menu.pricingInfo
          const budgetPerPerson = this.getBudgetPerPersonValue()

          let isOverBudget = false
          if (budgetPerPerson) {
            isOverBudget =
              menuPricePerPerson.all > budgetPerPerson ||
              menuPricePerPerson.entrees > budgetPerPerson
          }

          return (
            <div
              key={menu.id}
              onClick={() => this.setState({ showMenu: menu.id })}
              className={`group-menu-container ${!menu.active ? 'pink' : ''}`}
            >
              <FlexContainer flexDirection="row" justifyContent="space-between">
                <FlexContainer flexDirection="column">
                  <p>
                    <span
                      style={{ color: theme.textColor }}
                      className="group-menu-name font-semibold mr-2"
                    >
                      Partner:
                    </span>
                    {menu.chef.name}
                  </p>
                  <p>
                    <span
                      style={{ color: theme.textColor }}
                      className="group-menu-name font-semibold mr-2"
                    >
                      Menu Name:
                    </span>
                    {menu.name}
                    {isOverBudget && (
                      <span
                        style={{ backgroundColor: '#facc15' }}
                        className="text-white ml-2 px-2 py-1 rounded-lg text-xs"
                      >
                        Over Client Budget
                      </span>
                    )}
                  </p>
                  <p>
                    <span
                      style={{ color: theme.textColor }}
                      className="group-menu-name font-semibold mr-2"
                    >
                      Order Count:
                    </span>
                    {countMap[menu.id] || 0}
                  </p>
                  {editCutoffTimeModal && editCutoffMenu && (
                    <EditDateMenuCutoffModal
                      editMenu={editCutoffMenu}
                      dateMenuCutoffTime={formattedCutoff}
                      displayFailureMessage={this.props.displayFailureMessage}
                      displayWarningMessage={this.props.displayWarningMessage}
                      hideModal={() =>
                        this.setState({
                          editCutoffTimeModal: false,
                          editCutoffMenu: undefined,
                        })
                      }
                      saveMenu={(menu: Menu) => this.handleSaveCutoffTime(menu)}
                      showConfirmationModal={this.props.showConfirmationModal}
                    />
                  )}
                  {updatedCutoffMap[menu.id] && (
                    <span className="text-red-800 font-bold">
                      Cutoff Updated
                    </span>
                  )}
                  <div className="flex flex-row space-between">
                    <div>
                      <p className="font-semibold">
                        <span
                          style={{ color: theme.textColor }}
                          className="group-menu-name mr-2"
                        >
                          Menu Cutoff Time:
                        </span>
                        {moment(menu.cutoffTime).format('lll z')}
                      </p>
                    </div>
                    {moment(formattedCutoff).isAfter(moment()) && (
                      <FlexContainer
                        flexDirection="row"
                        justifyContent="start"
                        width="30%"
                      >
                        <AuthorizedDisplay
                          roles={['master admin', 'chef lead']}
                        >
                          <div className="summary-header">
                            <button
                              onClick={() =>
                                this.setState({
                                  editCutoffTimeModal: true,
                                  editCutoffMenu: menu,
                                })
                              }
                              className="edit-button"
                            >
                              <div className="button-content">
                                <BiPencil />
                                <div>Edit</div>
                              </div>
                            </button>
                          </div>
                        </AuthorizedDisplay>
                        <TooltipModal
                          unicode="&#9432;"
                          width="400px"
                          information={
                            'Primary use of this edit button should to be fix an incorrectly entered menu card cutoff time.'
                          }
                          marginTop="20px"
                        />
                      </FlexContainer>
                    )}
                  </div>
                  {menu.chef.cutoffEmailSentAt && (
                    <p className="font-semibold">
                      <span
                        style={{ color: theme.textColor }}
                        className="group-menu-name mr-2"
                      >
                        Chef Email Sent At:
                      </span>
                      {moment(menu.chef.cutoffEmailSentAt).format('lll z')}
                    </p>
                  )}
                </FlexContainer>
                {!hasActiveOrders && (
                  <Button
                    label={<FaTrash />}
                    onClick={() => this.onRemoveMenu(idx, menu.id)}
                  />
                )}
              </FlexContainer>

              {showMenu === menu.id && (
                <div className="flex flex-row">
                  <div className="w-3/5">
                    <YSpacing height="10px" />
                    <Checkbox
                      label={`Active? ( Last Activated: ${
                        menu.lastActive
                          ? moment(menu.lastActive).format('MM-DD-YYYY h:mm a')
                          : 'N/A'
                      } )`}
                      testId={`${menu.id}-active`}
                      value={menu.active}
                      checked={menu.active}
                      onChange={this.onChangeMenuActive(idx)}
                    />
                    <Button
                      label="Sync Menu"
                      onClick={() => this.onSyncMenu(menu)}
                    />
                    {!!entrees.length &&
                      this.renderMenuItems(entrees, 'Entrees')}
                    {!!sides.length && this.renderMenuItems(sides, 'Sides')}
                    {!!drinks.length && this.renderMenuItems(drinks, 'Drinks')}
                    {!!desserts.length &&
                      this.renderMenuItems(desserts, 'Desserts')}
                  </div>
                  <div className="w-2/5 flex flex-col items-center">
                    {menuPricePerPerson && (
                      <>
                        <div>
                          <p className="font-semibold">
                            Estimated Price Per Person
                            <br />
                            (Entrees Only):
                          </p>
                          <p
                            className="font-semibold p-3 text-white bg-green-500 rounded-md my-2"
                            style={{
                              maxWidth: 'fit-content',
                              backgroundColor:
                                menuPricePerPerson.entrees > budgetPerPerson
                                  ? '#facc15'
                                  : '#48bb78',
                            }}
                          >
                            ${menuPricePerPerson.entrees.toFixed(2)}
                          </p>
                        </div>
                        {sides.length > 0 && (
                          <div>
                            <p className="font-semibold">
                              Estimated Price Per Person
                              <br />
                              (Entrees + Sides):
                            </p>
                            <p
                              className="font-semibold p-3 text-white bg-red-500 rounded-md my-2"
                              style={{
                                maxWidth: 'fit-content',
                                backgroundColor:
                                  menuPricePerPerson.all > budgetPerPerson
                                    ? '#facc15'
                                    : '#48bb78',
                              }}
                            >
                              ${menuPricePerPerson.all.toFixed(2)}
                            </p>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          )
        })}
        <Button
          width="100%"
          label={
            dateMenu.id
              ? forCalendarModal
                ? 'Stage Changes'
                : 'Save Changes'
              : 'Add Menus'
          }
          onClick={() => this.onStageMenus()}
        />

        {this.state.warningsModalOpen && (
          <ValidationsModal
            onClose={this.onCloseWarningsModal}
            onSave={() => this.onStageMenus(true)}
            validationErrors={this.state.validationErrors}
            validationWarnings={this.state.validationWarnings}
          />
        )}
      </div>
    )
  }
}

const BANNER_STYLES: Record<string, React.CSSProperties> = {
  off: {
    background: '#FFF3E0',
    border: '1px solid #F57C00',
    borderLeft: '4px solid #F57C00',
    borderRadius: '4px',
    padding: '10px 14px',
    marginBottom: '16px',
    fontSize: '13px',
    color: '#4E342E',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  unscheduled: {
    background: '#FFFDE7',
    border: '1px solid #F9A825',
    borderLeft: '4px solid #F9A825',
    borderRadius: '4px',
    padding: '10px 14px',
    marginBottom: '16px',
    fontSize: '13px',
    color: '#4E342E',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
}

const ScheduleBanner: React.FC<{
  type: 'off' | 'unscheduled'
  children: React.ReactNode
}> = ({ type, children }) => <div style={BANNER_STYLES[type]}>{children}</div>

const ScheduleBannerTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div style={{ fontWeight: 700, marginBottom: '2px' }}>{children}</div>

const ScheduleBannerRow: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div style={{ marginTop: '2px' }}>{children}</div>

export default DateMenusComponent
